<!-- 定时跟踪设置 -->
<template>
  <div class="campus-announcement">
    <el-checkbox size="medium" v-model="checked">是否开启定时跟踪</el-checkbox>
    <div v-if="checked" class="fuzzy-matching-top">
      <el-row class="top-first-line">
        <el-col :span="4">
          <el-form-item label=" 跟踪间隔（秒）：">
            <el-select filterable v-model="Dform.typeValue" placeholder="">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="bottomBox">
        <div class="headerNav">
          <span>类型</span>
          <span>时间段</span>
          <span>开始时间</span>
          <span>结束时间</span>
        </div>
        <hr>
        <div class="towTimeBox" v-for="item in listBox">
          <div class="TimeBox">
            <span class="gongwork">{{ item.gongzuori }}</span>
            <span class="timeOne">时段一</span>
            <span><input type="text" class="showTime" v-model="item.valuemin"></span>
            <span><input type="text" class="stopTime" v-model="item.valueBox"></span>
          </div>
          <div class="TimeBox" v-for="item2 in item.list">
            <span class="zuowork"></span>
            <span class="timeOne2">{{ item2.name }}</span>
            <span>
              <input type="text" class="showTime2" v-model="item2.value">
            </span>
            <span>
              <input type="text" class="stopTime2" v-model="item2.value2">
            </span>
          </div>
        </div>
      </div>
      <div class="timeStlyeBox">时间格式：HH:MM 列如：10：30</div>
      <el-button size="medium" class="timeButtonBaocun" type="" @click="timeFollowSetClick">保存设置</el-button>

    </div>
  </div>
</template>

<script>
import { timeFollowSet,timeFollowFind } from '@/assets/api/logapi.js'
import { ElMessage } from 'element-plus'

export default {
  components: {

  },
  data() {
    return {
      checked: false,
      options: [
        {
          label: '60',
          value: 60,
        },
        {
          label: '300',
          value: 300,
        },
        {
          label: '600',
          value: 600,
        },
        {
          label: '900',
          value: 900,
        }
      ],
      Dform: {
        typeValue: 60
      },
      listBox: [
        {
          valuemin: '',
          valueBox: '',
          gongzuori: '工作日',
          list: [
            {
              name: '时段二',
              value: '',
              value2: '',
            },
            {
              name: '时段三',
              value: '',
              value2: '',
            },
            {
              name: '时段四',
              value: '',
              value2: '',
            },
            {
              name: '时段五',
              value: '',
              value2: '',
            },
            {
              name: '时段六',
              value: '',
              value2: '',
            },
          ]
        },
        {
          gongzuori: '周六',
          valuemin: '',
          valueBox: '',
          list: [
            {
              name: '时段二',
              value: '',
              value2: '',
            },
            {
              name: '时段三',
              value: '',
              value2: '',
            },
            {
              name: '时段四',
              value: '',
              value2: '',
            },
            {
              name: '时段五',
              value: '',
              value2: '',
            },
            {
              name: '时段六',
              value: '',
              value2: '',
            },
          ]
        },
        {
          gongzuori: '周日',
          valuemin: '',
          valueBox: '',
          list: [
            {
              name: '时段二',
              value: '',
              value2: '',
            },
            {
              name: '时段三',
              value: '',
              value2: '',
            },
            {
              name: '时段四',
              value: '',
              value2: '',
            },
            {
              name: '时段五',
              value: '',
              value2: '',
            },
            {
              name: '时段六',
              value: '',
              value2: '',
            },
          ]
        },


      ]
    };
  },
  created() {
      this.setSysteTimeFollowSearch()
    console.log(this.Dform, 888);
  },
  mounted() {

  },
  methods: {
    jianting() {
      console.log(this.listBox, 789789);
    },
    setSysteTimeFollowSearch() {
      const params = {
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      timeFollowFind(params).then((res) => {
        console.log(res, '请求成功，定时跟踪');
       
        let data = res.data.data
        this.Dform.typeValue = data.followingInterval
        this.checked = data.followingOnOff
        if(data.workingDaysTime != null && data.workingDaysTime.length > 0){

          data.workingDaysTime.forEach( (item,index) => {
            if ( index == 0 ) {
              this.listBox[0].valuemin = item.startTime
              this.listBox[0].valueBox = item.endTime
            } else {
              this.listBox[0].list[index-1].value = item.startTime
              this.listBox[0].list[index-1].value2 = item.endTime
            }
          });
        }
          console.log(444444);
          if(data.saturdayTime != null && data.saturdayTime.length>0) {
            data.saturdayTime.forEach( (item,index) => {
              if ( index == 0 ) {
                this.listBox[1].valuemin = item.startTime
                this.listBox[1].valueBox = item.endTime
              } else {
                this.listBox[1].list[index-1].value = item.startTime
                this.listBox[1].list[index-1].value2 = item.endTime
              }
            });
          }
          console.log(6666666666);
          if(data.sundayTime != null && data.sundayTime.length>0) {
            data.sundayTime.forEach( (item,index) => {
              if ( index == 0 ) {
                this.listBox[2].valuemin = item.startTime
                this.listBox[2].valueBox = item.endTime
              } else {
                this.listBox[2].list[index-1].value = item.startTime
                this.listBox[2].list[index-1].value2 = item.endTime
              }
            });
          }
      }).catch((err) => {
        console.log(err, '请求失败');
        this.$message({
            type: 'error',
            message: '查询失败!'
          });
      })
    },
    timeFollowSetClick() {
      let setupFollowing = false
      let workingDaysTime = [] // 工作日
      let saturdayTime = [] // 周六
      let sundayTime = [] // 周日
      var reDateTime = /^(?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]$/;
      // var isDateTime = reDateTime.test('18:00');
      // console.log(isDateTime)
      for (let item of this.listBox) {
        if (item.gongzuori == '工作日') {
          if (item.valuemin != '' || item.valueBox != '') {
            setupFollowing = true
            workingDaysTime.push(
              {
                startTime: item.valuemin,
                endTime: item.valueBox,
              }
            )
          }
          for (let item2 of item.list) {
            if (item2.value != '' || item2.value2 != '') {
              setupFollowing = true
              workingDaysTime.push(
                {
                  startTime: item2.value,
                  endTime: item2.value2,
                }
              )
            }
          }
        }
        if (item.gongzuori == '周六') {
          if (item.valuemin != '' || item.valueBox != '') {
            setupFollowing = true
            saturdayTime.push(
              {
                startTime: item.valuemin,
                endTime: item.valueBox,
              }
            )
          }
          for (let item2 of item.list) {
            if (item2.value != '' || item2.value2 != '') {
              setupFollowing = true
              saturdayTime.push(
                {
                  startTime: item2.value,
                  endTime: item2.value2,
                }
              )
            }
          }
        }
        if (item.gongzuori == '周日') {
          if (item.valuemin != '' || item.valueBox != '') {
            setupFollowing = true
            sundayTime.push(
              {
                startTime: item.valuemin,
                endTime: item.valueBox,
              }
            )
          }
          for (let item2 of item.list) {
            if (item2.value != '' || item2.value2 != '') {
              setupFollowing = true
              sundayTime.push(
                {
                  startTime: item2.value,
                  endTime: item2.value2,
                }
              )
            }
          }
        }
      }
      console.log(workingDaysTime, setupFollowing, '工作日');
      console.log(saturdayTime, '周六');
      console.log(sundayTime, '周日');
      for ( let item of workingDaysTime) {
        if(item.startTime != '') {
          console.log(item.startTime,reDateTime.test(item.startTime));
          if (reDateTime.test(item.startTime) != true) return ElMessage.error("工作日开始时间格式有误")
        } else if (item.endTime != '') {
          console.log(item.endTime,reDateTime.test(item.endTime));
          if (reDateTime.test(item.endTime) != true) return ElMessage.error("工作日结束时间格式有误")
        }
      }
      for ( let item of saturdayTime) {
        if(item.startTime != '') {
          console.log(item.startTime,reDateTime.test(item.startTime));
        if (reDateTime.test(item.startTime) != true) return ElMessage.error("周六开始时间格式有误")
        } else if (item.endTime != '') {
          console.log(item.endTime,reDateTime.test(item.endTime));
          if (reDateTime.test(item.endTime) != true) return ElMessage.error("周六结束时间格式有误")
        }
      }
      for ( let item of sundayTime) {
        if(item.startTime != '') {
          console.log(item.startTime,reDateTime.test(item.startTime));
          if (reDateTime.test(item.startTime) != true) return ElMessage.error("周日开始时间格式有误")
        } else if (item.endTime != '') {
          console.log(item.endTime,reDateTime.test(item.endTime));
          if (reDateTime.test(item.endTime) != true) return ElMessage.error("周日结束时间格式有误")
        }
      }
      console.log(88888,this.Dform.typeValue,);
      let params = {
        workingDaysTime,
        saturdayTime,
        sundayTime,
        followingOnOff: true,
        followingInterval: this.Dform.typeValue,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      timeFollowSet(params).then((res)=> {
        console.log(this.tableData,res,'');
        this.$message({
          type: 'success',
          message: '保存成功!'
        }); 
        this.listBox.forEach((item,index)=> {
          item.valuemin = ''
          item.valueBox = ''
          item.list.forEach((item2,index2)=> {
            item2.value = ''
            item2.value2 = ''
          })
        })
        this.setSysteTimeFollowSearch()

      }).catch((err)=> {
          // console.log(err);
          this.$message({
            type: 'error',
            message: '保存失败!'
          });
      })
    },
  },
};
</script>

<style scoped lang="scss">
.campus-announcement {
  height: 96%;
  background-color: #fff;
  padding: 20px;
  overflow: auto;

  .fuzzy-matching-top {
    // height: 100%;
    // border: 1px solid #ccc;
    padding: 20px 20px;

  }

  :deep() {

    .el-form-item--small .el-form-item__label {
      font-weight: 700;
      font-size: 18px;
      line-height: 40px;
      // color: red;
    }

    .el-select .el-input__wrapper {
      height: 40px;
      width: 70px;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      margin-left: 20px;
    }

    .el-checkbox__input.is-checked+.el-checkbox__label {
      font-size: 18px;

    }

    .el-checkbox__label {
      font-size: 18px;

    }

    .el-checkbox__inner {
      margin-left: 20px;

    }
  }

  .bottomBox {
    height: 650px;
    border: 1px solid #ccc;
    width: 1000px;
  }

  .headerNav {
    display: flex;
    height: 80px;
    line-height: 80px;

    span {
      flex: 20%;
      text-align: center;
    }
  }

  input {
    border: 1px solid #000;
  }

  .towTimeBox {
    padding-top: 20px;
    // margin-top: 30px;
  }

  .TimeBox {
    text-align: center;
    display: flex;
    flex: 25%;

    span {
      width: 25%;
      text-align: center;
    }
  }

  .timeStlyeBox {
    color: gray;
    margin-left: 780px;
    font-size: 14px;
  }

  .timeButtonBaocun {
    color: gray;

    margin-left: 400px;
  }

}
</style>
